import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  &.ant-radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    .ant-radio-wrapper {\n      position: relative;\n      font-size: 16px;\n      font-weight: 600;\n      display: flex;\n      padding: 16px;\n      border: 1px solid ",
        ";\n      border-radius: 6px;\n      margin-inline-end: 0;\n\n      > span:not(.ant-radio) {\n        width: 100%;\n      }\n\n      :hover {\n        background-color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    }\n\n    .ant-radio-wrapper-checked {\n      border: 1px solid ",
        ";\n      background-color: ",
        ";\n    }\n\n    span.ant-radio + * {\n      padding-inline-end: 0;\n      padding-inline-start: 12px;\n    }\n\n    @media (max-width: 768px) {\n      gap: 12px;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Radio as AntedRadio } from "antd";
export const Radio = (param)=>{
    let { radioOptions , ...props } = param;
    return /*#__PURE__*/ _jsx(RadioWrapper, {
        ...props,
        children: radioOptions.map((option)=>/*#__PURE__*/ _jsx(AntedRadio, {
                value: option.value,
                children: option.label
            }, option.value))
    });
};
const RadioWrapper = styled(AntedRadio.Group).withConfig({
    componentId: "sc-4ca82fe2-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_50, (props)=>props.theme.new.colors.sol_indigo_0, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_0);
